import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import OrderNow from "../Common/OrderNow.js";
import * as actionCreator from "../../../action/index.js";
import CurrencyFormat from "react-currency-format";
import TermsInfo from "../../Modals/TermsInfo.js";
import { const_var, params } from "../../../redux/reducers/reducer.js";
import { calcNumOfWalls, capitalize, checkName, hasGableLeanto,  replaceLeanWithBuilding } from "../../../redux/reducers/utils.js";
import { LEAN_TYPE_NUM_TO_STR } from "../../../Constants/constant.js";
import { InsulationSummary, RenderNonLTInsulation } from "./InsulationSummary.jsx";
import ColorSummarySection, { MaterialSummary, WainsCoatSummarySection } from "./ColorSummarySection.jsx";
import { ConnectionFeeSummary, CrossBracingSummary, ExtraOptionsSummary, NotesAndExtraSummary, OtherInfoSummary } from "./ExtraOptionsSummary.jsx";
import { BuildingDimensionSummary, BuildingWallsSummary } from "./CentralBuildingSummary.jsx";
import { ComponentSummary, CupolaSummary } from "./ComponentSummary.jsx";
import LeantoSummary from "./LeantoSummary.jsx";
import { upperCaseFirst } from "../../../redux/reducers/building_pricing/pricingReducer.js";
import { heritageNoInsulation } from "../../../helpers/insulation_pricing/insulationPricing.helper.js";

const setCupolaData = (cupolaData) => {
	if (!cupolaData || cupolaData.length === 0) return [];
	return cupolaData.reduce((acc, cupola) => {
		const key = `${cupola.cupolaName}-${cupola.dimension}`;
		const index = acc.findIndex((group) => group.key === key);
		if (index === -1) {
			acc.push({
				key,
				cupolaName: cupola.cupolaName,
				dimension: cupola.dimension,
				quantity: 1,
				totalPrice: parseFloat(cupola.cupola_price)
			});
		} else {
			acc[index].quantity++;
			acc[index].totalPrice += parseFloat(cupola.cupola_price);
		}
		return acc;
	}, []);
};
const resolveHeritageFlags = (compareParamData, editCheckForHeritage, compData, params) => {
	const hasCompData = compData !== "";
	const mapData = hasCompData ? compareParamData : params;
	const buildingArea = {
		CenterBuilding: "center",
		LeftLean: "leftLean",
		RightLean: "rightLean",
		FrontLean: "frontLean",
		BackLean: "backLean"
	};
	return Object.fromEntries(Object.entries(buildingArea).map(([key, value]) => [`heritageNoInsulationCase${key}`, heritageNoInsulation(mapData, editCheckForHeritage, hasCompData, value, compData)]));
};

const resolveShowCustomInsulation = ({
	summaryViewData,
	heritageNoInsulationCaseCenterBuilding,
	heritageNoInsulationCaseLeftLean,
	heritageNoInsulationCaseRightLean,
	heritageNoInsulationCaseFrontLean,
	heritageNoInsulationCaseBackLean,
	params
}) => {
	let showCustomInsulation = false;

	if (summaryViewData != undefined && params.p_c_i == true) {
		if (Object.keys(summaryViewData?.insulation_type?.insulation_wall || {}).length > 0) {
			if (Object.values(summaryViewData.insulation_type.insulation_wall).find((s) => s == true) != undefined) {
				showCustomInsulation = true;
			}
		}

		if (summaryViewData.leanto != undefined && summaryViewData.leanto.length > 0) {
			Object.entries(summaryViewData.leanto).map(([key, value]) => {
				const hasWall = (v) =>
					v.insulation_type != undefined &&
					v.insulation_type.insulation_wall != undefined &&
					Object.keys(v.insulation_type.insulation_wall).length > 0 &&
					Object.values(v.insulation_type.insulation_wall).find((s) => s == true) != undefined;

				if (value.leanto_type == 1 && hasWall(value) && !heritageNoInsulationCaseLeftLean) showCustomInsulation = true;
				if (value.leanto_type == 2 && hasWall(value) && !heritageNoInsulationCaseRightLean) showCustomInsulation = true;
				if (value.leanto_type == 3 && hasWall(value) && !heritageNoInsulationCaseFrontLean) showCustomInsulation = true;
				if (value.leanto_type == 4 && hasWall(value) && !heritageNoInsulationCaseBackLean) showCustomInsulation = true;
			});
		}
	}

	if (summaryViewData != undefined && (params.p_r_o == true || params.p_f_i == true)) {
		if (summaryViewData.insulation != undefined) {
			showCustomInsulation = !heritageNoInsulationCaseCenterBuilding;
		}

		if (summaryViewData.leanto != undefined && summaryViewData.leanto.length > 0) {
			Object.entries(summaryViewData.leanto).map(([key, value]) => {
				if (value.leanto_type == 1 && summaryViewData.insulation != undefined) {
					showCustomInsulation = !heritageNoInsulationCaseLeftLean;
				}
				if (value.leanto_type == 2 && summaryViewData.insulation != undefined) {
					showCustomInsulation = !heritageNoInsulationCaseRightLean;
				}
				if (value.leanto_type == 3 && summaryViewData.insulation != undefined) {
					showCustomInsulation = !heritageNoInsulationCaseFrontLean;
				}
				if (value.leanto_type == 4 && summaryViewData.insulation != undefined) {
					showCustomInsulation = !heritageNoInsulationCaseBackLean;
				}
			});
		}
	}

	return showCustomInsulation;
};

const resolveTrussName = ({ isFromComapre, item, const_var, params, comparePricingData }) => {
	let filterDataTruss = [];
	let trussName = "";

	if (isFromComapre) {
		if ((item?.compareManufactureIndex == "_1" || item?.compareManufactureIndex == "_2") && comparePricingData?.truss_name?.length > 0) {
			if (const_var?.a_p_d_a?.truss_name?.length > 1) {
				let initialTrussData = const_var.a_p_d_a?.truss_name.filter((i) => i.name.includes(params.trussType) && (i.is_default == true || i.is_show == true));
				filterDataTruss = comparePricingData.truss_name.filter((data) => data.name.includes(params.trussType) == true && initialTrussData.length > 0);

				if (filterDataTruss.length == 0) {
					if (initialTrussData.length > 0) {
						let comapreTrussData = comparePricingData.truss_name?.filter((i) => i.is_show == true && i.is_default == true);
						trussName = comapreTrussData != undefined && comapreTrussData.length > 0 ? comapreTrussData[0] : "";
					} else {
						trussName = undefined;
					}
				}

				if (filterDataTruss.length > 0) {
					trussName = filterDataTruss[0];
				}
			} else if (const_var?.a_p_d_a?.truss_name?.length == 1) {
				trussName = const_var.a_p_d_a.truss_name[0].is_show == 1 ? "" : undefined;
			}
		} else if (item.compareManufactureIndex == "0") {
			if (const_var?.a_p_d_a?.truss_name?.length > 1) {
				filterDataTruss = const_var.a_p_d_a.truss_name.filter((data) => data.name.includes(params.trussType) == true && (data.is_default == true || data.is_show == true));
				trussName = filterDataTruss.length > 0 ? filterDataTruss[0] : undefined;
			}
			if (const_var?.a_p_d_a?.truss_name?.length == 1) {
				const t = const_var.a_p_d_a.truss_name[0];
				trussName = t?.is_show == 1 && t?.is_default == 1 ? t : undefined;
			}
		} else {
			if (const_var?.a_p_d_a?.truss_name?.length == 1) {
				const t = const_var.a_p_d_a.truss_name[0];
				trussName = t.is_show == 1 && t.is_default == 1 ? "" : undefined;
			}
		}
	} else {
		if (const_var?.a_p_d_a?.truss_name?.length > 1) {
			filterDataTruss = const_var.a_p_d_a.truss_name.filter((data) => data.name.includes(params.trussType) == true);
			if (filterDataTruss.length == 0) {
				trussName = const_var.a_p_d_a.truss_name.filter((data) => data.is_default == true)[0];
			}
			if (filterDataTruss.length > 0) {
				let isDefaultTruss = filterDataTruss.filter((data) => data.is_default == true || data.is_show == true);
				trussName = isDefaultTruss != undefined && isDefaultTruss.length > 0 ? isDefaultTruss[0] : undefined;
			}
		} else if (const_var?.a_p_d_a?.truss_name?.length == 1) {
			trussName = const_var.a_p_d_a.truss_name[0]?.is_show == 1 ? const_var.a_p_d_a.truss_name[0] : undefined;
		}
	}

	return trussName;
};

const Summary = (props) => {
	const [showMoreContent, setShowMoreContent] = useState(false);
	const [showMoreContentForExclusions, setShowMoreContentForExclusions] = useState(false);
	const [isTruncated, setIsTruncated] = useState(false);
	const combinedRef = useRef(null);

	const checkTruncation = useCallback(() => {
		const el = combinedRef.current;
		if (el) {
			setIsTruncated(el.scrollHeight > el.clientHeight);
		}
	}, []);

	useEffect(() => {
		setTimeout(checkTruncation, 0);
	}, [checkTruncation]);

	useEffect(() => {
		checkTruncation();
	}, [props, checkTruncation]);

	const scrollToOption = () => {
		setShowMoreContent(true);
		setTimeout(() => {
			let ele = document.getElementById("detail-description");
			ele.scrollIntoView(0, 0);
		}, 10);
	};

	const { electricity, inside_city, installation_ready, surface_level, permit, pdf_price_breakdown, dont_show_processing_fee_pdf, welded_spacer, notched_lip, space_around_building, site_clear_obstacle } =
		props.const_var.post_data.building !== undefined && props.const_var.post_data.building.order_extra_items;

	let showEndWithLean = false;
	let showSideWithLean = false;
	props.const_var.leanto?.forEach((lean) => {
		if (lean.leanto_type == 1 || lean.leanto_type == 2) showSideWithLean = true;
		if (lean.leanto_type == 3 || lean.leanto_type == 4) showEndWithLean = true;
	});

	let extraItemLabel = ["Jtrim", "End Jtrim", "End Cross Bracing", "Side Cross Bracing"];
	if (props.item?.compareManufactureIndex == "_1") extraItemLabel = [];
	if (props.item?.compareManufactureIndex == "_2") extraItemLabel = [];

	let isUserData = localStorage.getItem("userData") ? true : false;

	const firstManufactureParamData = props.const_var.ComparisionDataArray[props.params.m_s_n_1]?.paramsData ?? "";
	const secondManufacturParamData = props.const_var.ComparisionDataArray[props.params.m_s_n_2]?.paramsData ?? "";
	const compareParamData = props.item != undefined && props.item.compareManufactureIndex == "_2" ? secondManufacturParamData : firstManufactureParamData;

	const firstManufacturePricingData = props.const_var.ComparisionDataArray[props.params.m_s_n_1]?.pricing_data ?? "";
	const secondManufacturPricingData = props.const_var.ComparisionDataArray[props.params.m_s_n_2]?.pricing_data ?? "";
	const comparePricingData = props.item != undefined && props.item.compareManufactureIndex == "_2" ? secondManufacturPricingData : firstManufacturePricingData;

	let firstManuCompareData = props.const_var.ComparisionDataArray[props.params.m_s_n_2]?.post_data?.building ?? "";
	const roof_pitch_arry_FIRST = props.const_var.ComparisionDataArray[props.params.m_s_n_2]?.pricing_data?.roof_pitch ?? null;
	if (firstManuCompareData) firstManuCompareData["roof_pitch_arr"] = roof_pitch_arry_FIRST;

	let secondManuCompareData = props.const_var.ComparisionDataArray[props.params.m_s_n_1]?.post_data?.building ?? "";
	const roof_pitch_arry_SECOND = props.const_var.ComparisionDataArray[props.params.m_s_n_1]?.pricing_data?.roof_pitch ?? null;
	if (secondManuCompareData) secondManuCompareData["roof_pitch_arr"] = roof_pitch_arry_SECOND;

	let compareData = props.item == undefined ? "" : props.item.compareManufactureIndex == "0" ? "" : props.item.compareManufactureIndex == "_2" ? firstManuCompareData : secondManuCompareData;

	let summaryViewData = props.item != undefined ? compareData : const_var.post_data?.building ? JSON.parse(JSON.stringify(const_var.post_data.building)) : {};

	if (props.item?.compareManufactureIndex == "0") {
		summaryViewData = const_var.post_data != undefined && const_var.post_data?.building;
		if (const_var.post_data?.building.leanto != undefined && const_var.post_data?.building.leanto.length > 1) {
			summaryViewData.leanto = const_var.post_data?.building.leanto?.sort((a, b) => a.leanto_type - b.leanto_type);
		}
	}

	if (props.item != undefined && (props.item.compareManufactureIndex == "_2" || props.item.compareManufactureIndex == "_1") && compareData.leanto != undefined && compareData.leanto.length > 0) {
		summaryViewData.leanto = compareData.leanto?.sort((a, b) => a.leanto_type - b.leanto_type);
	}

	let filterLegArr =
		const_var.ConditionArr.length > 0 &&
		const_var.ConditionArr !== undefined &&
		const_var?.ConditionArr[params.p_b_t]?.[params.p_r_s]?.CustomArray !== undefined &&
		const_var?.ConditionArr[params.p_b_t]?.[params.p_r_s]?.CustomArray?.length > 0 &&
		const_var?.ConditionArr[params.p_b_t]?.[params.p_r_s]?.CustomArray.filter((data) => {
			if (data.legs_type === const_var.legstype) return data;
			if (data.legs_type == "reinforced" && const_var.legstype == "single") return data;
		});

	let cupolaEntries = [];
	if (const_var.post_data?.building && const_var.post_data.building.cupolaEntries?.length > 0 && summaryViewData?.cupolaEntries) {
		cupolaEntries = setCupolaData(summaryViewData.cupolaEntries);
	}

	// ── Building data for compare ──────────────────────────────────────────────
	const firstManufactureBuildingData = props.const_var.ComparisionDataArray[props.params.m_s_n_1]?.building_data?.building?.find((item) => item.building_type?.building_id == props.params.p_b_t);
	const secondManufactureBuildingData = props.const_var.ComparisionDataArray[props.params.m_s_n_2]?.building_data?.building?.find((item) => item.building_type?.building_id == props.params.p_b_t);
	const compareBuildingData = props.item != undefined && props.item.compareManufactureIndex == "_2" ? secondManufactureBuildingData : firstManufactureBuildingData;

	// ── Notes & extra visibility ───────────────────────────────────────────────
	let isShowNotesAndExtra =
		summaryViewData != undefined &&
		summaryViewData.order_extra_items !== undefined &&
		Object.entries(summaryViewData.order_extra_items).filter(([key, value]) => {
			if (
				value != 0 &&
				value != "" &&
				key != "has_grvy" &&
				value != "no" &&
				value != "yes" &&
				key != "dont_show_processing_fee_pdf" &&
				key != "pdf_price_breakdown" &&
				key != "permit" &&
				key != "additional_note" &&
				key != "description" &&
				value != "None" &&
				value != "Generic Drawing" &&
				value != "Engineered Drawing" &&
				value != null
			)
				return key;
		});

	// ── Heritage insulation checks ─────────────────────────────────────────────
	const editCheckForHeritage =
		props.const_var.crmSetting.is_Edit == true &&
		summaryViewData?.manufacturer == 153 &&
		(summaryViewData.roof_style == 1 || summaryViewData.roof_style == 2) &&
		props.const_var.editAPIDataByResponse != undefined &&
		props.const_var.editAPIDataByResponse.data != undefined;

	let heritageNoInsulationCase = false;
	if (props.item?.compareManufactureIndex == "0") {
		heritageNoInsulationCase = heritageNoInsulation(props.params, editCheckForHeritage);
	} else {
		heritageNoInsulationCase = heritageNoInsulation(compareData, editCheckForHeritage, true);
	}

	let compData = "";
	if (props.const_var.ComparisionDataArray[props.params.m_s_n_1]?.paramsData != undefined) {
		compData = props.const_var.ComparisionDataArray[props.params.m_s_n_1];
	} else if (props.const_var.ComparisionDataArray[props.params.m_s_n_2]?.paramsData != undefined) {
		compData = props.const_var.ComparisionDataArray[props.params.m_s_n_2];
	}

	const { heritageNoInsulationCaseCenterBuilding, heritageNoInsulationCaseLeftLean, heritageNoInsulationCaseRightLean, heritageNoInsulationCaseFrontLean, heritageNoInsulationCaseBackLean } = resolveHeritageFlags(
		compareParamData,
		editCheckForHeritage,
		compData,
		props
	);

	// ── Free standing cross height ─────────────────────────────────────────────
	let showFSCrossHeight = false;
	if (const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0) {
		if (compareBuildingData == undefined || compareBuildingData == false) {
			showFSCrossHeight = true;
		} else {
			if (compareBuildingData != undefined && props.item.compareManufactureIndex != "_2" && props.item.compareManufactureIndex != "_1") {
				showFSCrossHeight = true;
			} else if (
				compareBuildingData != undefined &&
				compareBuildingData.fixed_new_leg_width != undefined &&
				compareBuildingData.fixed_new_leg_width.length > 0 &&
				(props.item.compareManufactureIndex == "_2" || props.item.compareManufactureIndex == "_1")
			) {
				showFSCrossHeight = true;
			} else {
				showFSCrossHeight = false;
			}
		}
	}
	const showCustomInsulation = resolveShowCustomInsulation({
		summaryViewData,
		heritageNoInsulationCaseCenterBuilding,
		heritageNoInsulationCaseLeftLean,
		heritageNoInsulationCaseRightLean,
		heritageNoInsulationCaseFrontLean,
		heritageNoInsulationCaseBackLean,
		params
	});

	// ── Truss name ─────────────────────────────────────────────────────────────
	const trussName = resolveTrussName({
		isFromComapre: props.isFromComapre,
		item: props.item,
		const_var: props.const_var,
		params: props.params,
		comparePricingData
	});

	// ── Standard truss label ───────────────────────────────────────────────────
	let standardTrussLabel = "Standard Truss";
	if (summaryViewData?.manufacturer == 153 && summaryViewData?.roof_style == 3) {
		standardTrussLabel = "Vertical Truss";
		if (summaryViewData?.other_building_type_name.includes("Premier")) {
			standardTrussLabel = "Premier Truss";
		}
	}

	// ── Side close cost check ──────────────────────────────────────────────────
	const side_close_cost_check = comparePricingData?.side?.length > 0 && comparePricingData?.side[0]?.side_close_cost == 0;

	// ── Leanto sorting ─────────────────────────────────────────────────────────
	if (summaryViewData?.leanto) {
		summaryViewData.leanto = summaryViewData.leanto.map((a) => ({
			...a,
			hasGable: a.leanto_style === "gable"
		}));
		summaryViewData.leanto = summaryViewData.leanto.toSorted((a, b) => {
			if (a.hasGable !== b.hasGable) return b.hasGable - a.hasGable;
			return a.leanto_type - b.leanto_type;
		});
	}

	// ── Misc ───────────────────────────────────────────────────────────────────
	const checkNatCarport = props.const_var.crmSetting.main_domain_url != undefined && props.const_var.crmSetting.main_domain_url == "nationalcarportsonline.com";

	const id = props.item?.compareManufactureIndex ? props.item?.compareManufactureIndex?.replace("0", "") : "";
	const msnValue = props.params[`m_s_n${id}`]?.toString()?.split("_")?.[0];
	const manufacturerDoorName = props.params.doorNames[msnValue];
	const showItWithZero = [75, 39, 184];

	const cbLeftWallName =
		(summaryViewData.left_wall != "close" &&
		summaryViewData.left_wall != "open" &&
		summaryViewData.left_wall != "one_fourth_close" &&
		summaryViewData.left_wall != "three_fourth_close" &&
		summaryViewData.left_wall != "half_close"
			? summaryViewData.left_wall + " Panel"
			: props.const_var.TypeWallName[summaryViewData != undefined ? summaryViewData.left_wall : 0]) +
		(summaryViewData != undefined && props.params.p_c_p_l == true && comparePricingData?.panel?.[0]?.cut_panel_cost != 0 ? "+ Cut Panel " : "");

	const cbRightWallName =
		(summaryViewData.right_wall != "close" &&
		summaryViewData.right_wall != "open" &&
		summaryViewData.right_wall != "one_fourth_close" &&
		summaryViewData.right_wall != "three_fourth_close" &&
		summaryViewData.right_wall != "half_close"
			? summaryViewData.right_wall + " Panel"
			: props.const_var.TypeWallName[summaryViewData != undefined ? summaryViewData.right_wall : 0]) +
		(summaryViewData != undefined && props.params.p_c_p_r == true && comparePricingData?.panel?.[0]?.cut_panel_cost != 0 ? "+ Cut Panel " : "");

	const sidingMaterialName = summaryViewData?.siding_obj?.label != undefined ? summaryViewData.siding_obj.label : summaryViewData?.siding_obj?.label?.replaceAll("_", " ");

	// ── Render ─────────────────────────────────────────────────────────────────
	return (
		<div className="building-elements-sec summary-component no-price-component">
			<div className="building-elements-sec-mid ">
				<div className="building-elements-sec-mid-scroll">
					<div className={`summary-info-wrapper ${props.const_var.crmSetting.is_quote_Edit && "quote-edit-summary-info-wrapper"}`}>
						<div className="summary-section">
							<div className="section-title-wrapper mt-0 ">
								<h6 className="section-title mb-0">Base</h6>
							</div>
							<div className="highlight-with-bg ">
								<div className="summary-row">
									<div className="summary-label">
										<span className="summary-label-title">Building Name</span>
										{" - "}
										<span className="dark-span">
											{summaryViewData != undefined ? (const_var.isLTBuilding ? summaryViewData?.display_building_type_name : summaryViewData?.other_building_type_name) : ""}
										</span>
									</div>
								</div>
								<div className="summary-row">
									<div className="summary-label">
										<span className="summary-label-title">Roof Style</span>
										{" - "}
										<span className="dark-span">{summaryViewData != undefined ? summaryViewData.roof_style_name : 0}</span>
									</div>
								</div>
								<div className="installation-summary">
									<div className="summary-row mb-0">
										<div className="summary-label">
											<span className="summary-label-title">Installation Surface</span>
											{" - "}
											<span className="dark-span">{summaryViewData != undefined ? upperCaseFirst(summaryViewData.installation_surface) : ""}</span>
										</div>
									</div>
								</div>
							</div>

							<hr />
							<div className="section-title-wrapper ">
								<h6 className="section-title mb-0">Certification</h6>
							</div>
							<hr />

							<CupolaSummary summaryViewData={summaryViewData} cupolaEntries={cupolaEntries} const_var={props.const_var} />

							{sidingMaterialName?.toLowerCase() !== "metal" && summaryViewData?.siding_obj?.name == props.const_var?.selSidingOption && (
								<MaterialSummary sidingMaterialName={sidingMaterialName} summaryViewData={summaryViewData} />
							)}

							{!params.isBreezeway && (
								<>
									<div className="section-title-wrapper ">
										<h6 className="section-title mb-0">{`Center ${props.const_var.isLTBuilding ? "(Building 1)" : "Building"}`}</h6>
									</div>
									<BuildingDimensionSummary
										summaryViewData={summaryViewData}
										standardTrussLabel={standardTrussLabel}
										trussName={trussName}
										filterLegArr={filterLegArr}
										compareData={compareData}
										showFSCrossHeight={showFSCrossHeight}
										props={props}
									/>
									<BuildingWallsSummary
										summaryViewData={summaryViewData}
										params={props.params}
										const_var={props.const_var}
										cbLeftWallName={cbLeftWallName}
										cbRightWallName={cbRightWallName}
										side_close_cost_check={side_close_cost_check}
									/>
									<div className="highlight-with-bg">
										{summaryViewData != undefined && summaryViewData.leanto != undefined && summaryViewData.leanto.length > 0 && (
											<LeantoSummary
												summaryViewData={summaryViewData}
												const_var={props.const_var}
												params={props.params}
												side_close_cost_check={side_close_cost_check}
												extraItemLabel={extraItemLabel}
												compareParamData={compareParamData}
											/>
										)}
									</div>
								</>
							)}

							{!(props.params.p_i_o == "0") && (
								<InsulationSummary const_var={props.const_var} summaryViewData={summaryViewData} heritageNoInsulationCaseCenterBuilding={heritageNoInsulationCaseCenterBuilding} />
							)}
							<RenderNonLTInsulation
								params={props.params}
								const_var={props.const_var}
								item={props.item}
								summaryViewData={summaryViewData}
								compareData={compareData}
								compareParamData={compareParamData}
								comparePricingData={comparePricingData}
								showCustomInsulation={showCustomInsulation}
								heritageNoInsulationCaseCenterBuilding={heritageNoInsulationCaseCenterBuilding}
								heritageNoInsulationCaseLeftLean={heritageNoInsulationCaseLeftLean}
								heritageNoInsulationCaseRightLean={heritageNoInsulationCaseRightLean}
								heritageNoInsulationCaseFrontLean={heritageNoInsulationCaseFrontLean}
								heritageNoInsulationCaseBackLean={heritageNoInsulationCaseBackLean}
							/>

							<hr />
							<div className="section-title-wrapper ">
								<h6 className="section-title mb-0">Colors</h6>
							</div>
							<ColorSummarySection compareParamData={compareParamData} summaryViewData={summaryViewData} params={props.params} />
							<hr />
						</div>

						{summaryViewData != undefined && summaryViewData.entry_points != undefined && summaryViewData.entry_points.length > 0 ? (
							<div className="installation-summary">
								<div className="section-title-wrapper ">
									<h6 className="section-title mb-0">Components</h6>
								</div>
							</div>
						) : null}
						<ComponentSummary summaryViewData={summaryViewData} params={props.params} const_var={props.const_var} manufacturerDoorName={manufacturerDoorName} showPriceDetail={props.showPriceDetail} />

						<hr />

						{props.params.p_w_c_n == true ? <WainsCoatSummarySection compareParamData={compareParamData} summaryViewData={summaryViewData} params={props.params} /> : null}

						{summaryViewData?.extra_items?.length > 0 || summaryViewData?.connection_fee_end || summaryViewData?.connection_fee_side || summaryViewData?.order_extra_items || props.params.p_i_o != 0 ? (
							<div className="section-title-wrapper ">
								<h6 className="section-title mb-0">Options</h6>
							</div>
						) : null}
						<div className="highlight-with-bg">
							<ExtraOptionsSummary
								options={summaryViewData?.extra_items}
								extraItemLabel={extraItemLabel}
								params={props.params}
								compareParamData={compareParamData}
								buildingType={"center"}
								extraAddOnArray={summaryViewData?.extraAddOnItemsArray}
							/>
							<ConnectionFeeSummary props={props} summaryViewData={summaryViewData} showSideWithLean={showSideWithLean} showItWithZero={showItWithZero} />
						</div>

						{summaryViewData != undefined && summaryViewData.extra_price_cal != undefined ? (
							<div className="section-title-wrapper">
								<h6 className="section-title mb-0">Other Information</h6>
							</div>
						) : null}
						<OtherInfoSummary summaryViewData={summaryViewData} props={props} checkNatCarport={checkNatCarport} />
						<hr />

						{!props.isFromComapre && (
							<>
								{summaryViewData != undefined && summaryViewData.order_extra_items != undefined && isShowNotesAndExtra.length > 0 ? (
									<div className="notes-xtra-sec">
										<div className={"section-title-wrapper "}>
											<h6 className="section-title mb-0">Notes & Extra</h6>
										</div>
										<NotesAndExtraSummary summaryViewData={summaryViewData} props={props} isUserData={isUserData} />
									</div>
								) : null}
								<hr />
							</>
						)}

						{!props.isShowComparePriceModal && (
							<>
								<div className="section-title-wrapper ">
									<h6 className="section-title mb-0">Disclaimer</h6>
								</div>
								<TermsInfo />
							</>
						)}

						{props.isFromComapre != true && props.const_var.crmSetting.is_hide_discount != false && const_var.discount_info && (
							<div className="discount-description-wrapper">
								<div id="combined-discount-description" className={`discount-description ${!showMoreContent ? "show-ellipsis" : ""}`} ref={combinedRef}>
									<p>
										{props.const_var.loginSession == true ? "Specials:" : ""} {const_var.discount_info.discount_name} - {const_var.discount_info.offer_name} - {const_var.discount_info.amount}% on{" "}
										{checkName(const_var.discount_info.building_names)} price range ${const_var.discount_info.price_from} - ${const_var.discount_info.price_to}, States -{" "}
										{const_var.discount_info.state_names}
									</p>
									{props.const_var.discount_info.exclusions_for_crm?.arr?.length > 0 && (
										<p>
											{"Discount Exclusions:"} {props.const_var.discount_info.exclusions_for_crm.arr.join(", ")}
										</p>
									)}
								</div>
								{!showMoreContent && isTruncated && (
									<span className="read-more-content" onClick={scrollToOption}>
										read more
									</span>
								)}
							</div>
						)}
					</div>
				</div>

				<div className={props.const_var.hide_price_calculation == 1 ? "d-none prices-total-deposit" : "prices-total-deposit"}>
					<ul>
						<li className="highlight-deposit">
							<aside class="deposit-price-label">Grand Total</aside>
							<aside class="deposit-price-value">
								<CurrencyFormat
									fixedDecimalScale="2"
									decimalSeparator="."
									decimalScale="2"
									value={
										summaryViewData != undefined && props.const_var.BuildingPriceArrar["new_down_payment_total"] != undefined
											? (
													summaryViewData.due_upon_installation +
													props.const_var.BuildingPriceArrar["new_down_payment_total"] +
													props.const_var.BuildingPriceArrar["custom_down_payment_total"] +
													props.const_var.BuildingPriceArrar["grvy_value"]
												).toFixed(2)
											: 0
									}
									displayType={"text"}
									thousandSeparator={true}
									prefix={"$"}
								/>
							</aside>
						</li>
					</ul>
				</div>
			</div>

			<div className="clearfix building-elements-sec-bottom d-none">
				{props.const_var.crmSetting.is_module_name == "inventory" ? (
					<></>
				) : (
					<>
						<OrderNow
							i_g_A_y={props.const_var.i_g_A_y}
							order_now={props.const_var.crmSetting.order_now}
							is_quote_Edit={props.const_var.crmSetting.is_quote_Edit}
							form_action={props.const_var.crmSetting.form_action}
							is_loggedin={props.const_var.loginSession}
						/>
					</>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return { ...state.reducer, ...state.orderExtrasReducer };
};
export default connect(mapStateToProps, actionCreator)(Summary);

export const WallOrientation = ({ summaryViewData, side_close_cost_check, params }) => {
	let orientationName = "";
	if (summaryViewData && summaryViewData.siding_obj != undefined && summaryViewData.siding_obj.name == "metal") {
		orientationName = params.p_v_w == true ? " Vertical" : side_close_cost_check ? " Vertical" : " Horizontal";
	} else {
		if (summaryViewData && summaryViewData.siding_obj != undefined && summaryViewData.wallOrientation && summaryViewData.wallOrientation != "") {
			orientationName = summaryViewData.wallOrientation == "vertical" ? "Vertical" : summaryViewData.wallOrientation == "horizontal" ? "Horizontal" : "";
		}
	}

	if (orientationName === "") return null;

	return (
		<div className="summary-row d-flex justify-content-between">
			<div className="summary-label">
				<span className="summary-label-title">{`Panel Orientation - ${orientationName}`}</span>
			</div>
		</div>
	);
};

export const properCase = (str) => {
	if (str !== undefined && str !== "" && typeof str == "string") {
		return str.replace(/\w\S*/g, function (txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		});
	} else {
		return str;
	}
};

export const showTrussName = (data) => {
	let isShowTruss = false;
	let leanWidth = null,
		leanData = null;

	if (data.leanto_type == 1) {
		leanWidth = params.lean_p_w;
		leanData = const_var.leanGetDataLeft;
	}
	if (data.leanto_type == 2) {
		leanWidth = params.leanR_p_w;
		leanData = const_var.leanGetDataRight;
	}
	if (data.leanto_type == 3) {
		leanWidth = params.leanF_p_w;
		leanData = const_var.leanGetDataFront;
	}
	if (data.leanto_type == 4) {
		leanWidth = params.leanB_p_w;
		leanData = const_var.leanGetDataBack;
	}

	let isInRange = (truss) => leanWidth <= truss.max_width && leanWidth >= truss.min_width;
	let allTrusses = leanData?.truss_name ?? [];
	let eligbleTrusses = [];

	if (allTrusses.length > 0) {
		eligbleTrusses = allTrusses.filter((truss) => isInRange(truss));
		let checkpoint = allTrusses.filter((truss) => truss.is_show && isInRange(truss))?.[0];
		isShowTruss = !(!eligbleTrusses || !checkpoint);
	}

	return (
		<>
			{isShowTruss ? (
				<div className="summary-row d-flex justify-content-between">
					<div className="summary-label">
						<span className="summary-label-title">{"Truss Name - "}</span>
						<span className="dark-span">{params.l_t_p[LEAN_TYPE_NUM_TO_STR[data.leanto_type]]?.truss?.label ? params.l_t_p[LEAN_TYPE_NUM_TO_STR[data.leanto_type]].truss.label : data.truss_type_name}</span>
					</div>
					<div className="summary-info">
						<aside className="summary-info-right">
							{data?.truss_price != undefined && (
								<CurrencyFormat fixedDecimalScale="2" decimalSeparator="." decimalScale="2" value={data.truss_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
							)}
						</aside>
					</div>
				</div>
			) : (
				<></>
			)}
		</>
	);
};
export function SummaryRow({ label, children, price }) {
	return (
		<div className="summary-row d-flex justify-content-between">
			<div className="summary-label">
				{label}
				{children}
			</div>
			{price != null && price != undefined && (
				<div className="summary-info">
					<aside className="summary-info-right">
						<PriceDisplay value={price} />
					</aside>
				</div>
			)}
		</div>
	);
}
export function PriceDisplay({ value }) {
	const numValue = Number(value);
	if (value === null || value === undefined || Number.isNaN(numValue) || !Number.isFinite(numValue)) return null;
	return <CurrencyFormat fixedDecimalScale="2" decimalSeparator="." decimalScale="2" value={String(value)} displayType={"text"} thousandSeparator={true} prefix={"$"} />;
}
